import React from "react";
import ReactDOM from "react-dom";

import Raven from "raven-js";
import { BrowserRouter } from "react-router-dom";
// import GTM from "react-tag-manager";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

Raven.config(process.env.REACT_APP_RAVEN, {
  environment: process.env.REACT_APP_ENVIROMENT
}).install();
window.onunhandledrejection = function(evt) {
  Raven.captureException(evt.reason);
};

ReactDOM.render(
  <BrowserRouter basename="/i">
    {/* <GTM
      gtm={{
        id: process.env.REACT_APP_GTM,
        auth: "", // Optional
        preview: "" // Optional
      }}
      settings={{
        sendPageView: true, // default false
        pageView: {
          // default null
          event: "pageview", // default
          data: {}, // default

          settings: {
            locationProp: "pathname", // default
            sendAs: "url" // default
          }
        }
      }}
    > */}
    <App />
    {/* </GTM> */}
  </BrowserRouter>,
  document.getElementById("root")
);
registerServiceWorker();

(function() {
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  var AFFID = getParameterByName("AFFID");
  if (
    AFFID &&
    typeof AFFID === "string" &&
    AFFID.length >= 67 &&
    AFFID.substr(0, 3) === "AFF" &&
    window.localStorage
  ) {
    window.localStorage.setItem(
      "AFFID",
      JSON.stringify({
        id: AFFID,
        createdat: new Date().toISOString(),
        url: window.location.href
      })
    );
  }
})();
